import { LayoutConfig } from '@spartacus/storefront'

export const ebLayoutConfig: LayoutConfig = {
  layoutSlots: {
    LandingPage2Template: {
      pageFold: 'Section2B',
      slots: [
        'Section1',
        'Section2A',
        'Section2B',
        'Section2C',
        'Section3',
        'Section4',
        'Section5',
        'Matomo'
      ]
    },
    ContentPage1Template: {
      slots: ['BreadcrumbSlot', 'Section2A', 'Section2B', 'Matomo']
    },
    SearchResultsListPageTemplate: {
      slots: [
        'BreadcrumbSlot',
        'Section2',
        'ProductLeftRefinements',
        'SearchResultsListSlot',
        'Section4',
        'Matomo'
      ]
    },
    SearchResultsGridPageTemplate: {
      slots: [
        'BreadcrumbSlot',
        'Section2',
        'ProductLeftRefinements',
        'SearchResultsGridSlot',
        'Section4',
        'Matomo'
      ]
    },
    CartPageTemplate: {
      slots: [
        'BreadcrumbSlot',
        'TopContent',
        'CenterLeftContentSlot',
        'CenterRightContentSlot',
        'Matomo'
      ]
    },
    AccountPageTemplate: {
      slots: ['BreadcrumbSlot', 'BodyContent', 'SideContent', 'Matomo']
    },
    LoginPageTemplate: {
      slots: ['BreadcrumbSlot', 'LeftContentSlot', 'RightContentSlot', 'Matomo']
    },
    ErrorPageTemplate: {
      slots: ['BreadcrumbSlot', 'TopContent', 'MiddleContent', 'BottomContent', 'Matomo']
    },
    OrderConfirmationPageTemplate: {
      slots: ['BreadcrumbSlot', 'BodyContent', 'SideContent', 'Matomo']
    },
    MultiStepCheckoutSummaryPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent', 'Matomo']
    }
  }
}
